module.exports = __webpack_public_path__ + "static/media/loading.115a520e.svg";